export default "__VITE_ASSET__$Z8hMemT__"